import { render, staticRenderFns } from "./modalprofile.vue?vue&type=template&id=6c3d0cfe"
import script from "./modalprofile.vue?vue&type=script&lang=js"
export * from "./modalprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports